import { render, staticRenderFns } from "./ead-progresso-detalhe.vue?vue&type=template&id=5288af6d&scoped=true&"
import script from "./ead-progresso-detalhe.vue?vue&type=script&lang=js&"
export * from "./ead-progresso-detalhe.vue?vue&type=script&lang=js&"
import style0 from "./ead-progresso-detalhe.vue?vue&type=style&index=0&id=5288af6d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5288af6d",
  null
  
)

export default component.exports